
import { showInBetweenOutBetween, showStartEndLocalTime, showTime } from "../Data/Date";
import { notSet } from "../Data/Api";
import { RateProgram } from "./ApiTypes";

// Days of week enum matching C# backend
enum DaysOfWeek {
    Sunday    = 1 << 0,  // 1
    Monday    = 1 << 1,  // 2
    Tuesday   = 1 << 2,  // 4
    Wednesday = 1 << 3,  // 8
    Thursday  = 1 << 4,  // 16
    Friday    = 1 << 5,  // 32
    Saturday  = 1 << 6,  // 64
}

const DAY_NAMES_SHORT = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const DAY_NAMES_FULL = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

export function showApplicableDays(applicableDays: number | null, short: boolean = true): string {
    if (applicableDays === null) return "Any day";
    
    const dayNames = short ? DAY_NAMES_SHORT : DAY_NAMES_FULL;
    const selectedDays: string[] = [];
    
    [DaysOfWeek.Sunday, DaysOfWeek.Monday, DaysOfWeek.Tuesday, DaysOfWeek.Wednesday, 
     DaysOfWeek.Thursday, DaysOfWeek.Friday, DaysOfWeek.Saturday].forEach((day, index) => {
        if ((applicableDays & day) === day) {
            selectedDays.push(dayNames[index]);
        }
    });
    
    // Check for common patterns
    const allWeekdays = (applicableDays & 62) === 62; // Mon-Fri = 2+4+8+16+32 = 62
    const hasWeekend = (applicableDays & 65) !== 0; // Sun or Sat
    
    if (allWeekdays && !hasWeekend) {
        return "Weekdays";
    }
    
    if (selectedDays.length === 0) return "No days selected";
    if (selectedDays.length === 7) return "Any day";
    
    return selectedDays.join(", ");
}

export function rateProgramType( prog?: RateProgram ) {
    if( !prog ) {
        return "";
    }
    if( notSet( prog.inAfter )
     && notSet( prog.inBefore )
     && notSet( prog.outAfter )
     && notSet( prog.outBefore ) ) {
        return "Any time";
    }
    if( ( prog.inAfter && prog.outBefore && notSet( prog.inBefore ) && notSet( prog.outAfter ) ) ) {
        return `From ${showStartEndLocalTime( prog.inAfter, prog.outBefore )} `
    }
    if( prog.inBefore && prog.outBefore && notSet( prog.inAfter ) && notSet( prog.outAfter ) ) {
        return <div className="d-flex justify-content-center">
            <table cellPadding={3}>
                <thead>
                    <tr>
                        <td className="text-start">
                            Check-In
                        </td>
                        <td>
                            Before {showTime( prog.inBefore )}
                        </td>
                    </tr>
                    <tr>
                        <td className="text-start">
                            Check-Out
                        </td>
                        <td>
                            Before {showTime( prog.outBefore )}
                        </td>
                    </tr>
                </thead>
            </table>
        </div>;
    }
    if( prog.inAfter && prog.inBefore && prog.outAfter && prog.outBefore ) {
        var { inRange, outRange } = showInBetweenOutBetween( prog.inAfter, prog.inBefore, prog.outAfter, prog.outBefore );
        return <div className="d-flex justify-content-center">
            <table cellPadding={3}>
                <thead>
                    <tr>
                        <td className="text-start">
                            Check-In
                        </td>
                        <td>
                            {inRange}
                        </td>
                    </tr>
                    <tr>
                        <td className="text-start">
                            Check-Out
                        </td>
                        <td>
                            {outRange}
                        </td>
                    </tr>
                </thead>
            </table>
        </div>;
    }
}